import { api } from "./http-client";
import { ImportPreview } from "../interfaces/yacht-world-import.interface";

export const yachtWorldImportService = {
  preview: async (file: File): Promise<ImportPreview> => {
    const fd = new FormData();
    fd.append("file", file);
    const res = await api.request<ImportPreview>({
      url: "/admin/yacht-world-import/preview",
      method: "POST",
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },

  run: async (file: File, documentIds: string[]): Promise<{ taskId: string }> => {
    const fd = new FormData();
    fd.append("file", file);
    // Repeated fields, so the server's Transform sees a real array.
    documentIds.forEach((id) => fd.append("documentIds", id));
    const res = await api.request<{ taskId: string }>({
      url: "/admin/yacht-world-import/run",
      method: "POST",
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  },
};
